<template>
  <div class="locale-wrapper">
    <transition name="fade-out">
      <router-view
        v-show="!loading"
        :locale="locale"
        @loading="loading = true"
        @loaded="loading = false" />
      </transition>

    <transition name="fade-out">
      <loading-spinner v-show="loading" />
    </transition>
  </div>
</template>

<script>
import messages from '@/i18n/messages'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },
  data: () => ({
    loading: true
  }),
  props: {
    locale: {
      type: String,
      validator: value => Object.keys(messages).includes(value),
      required: true
    }
  },
  watch: {
    locale: {
      handler (value) {
        this.$i18n.locale = value
      },
      immediate: true
    }
  }
}
</script>

<style>
.fade-out-enter-active, .fade-out-leave-active {
  transition: opacity .5s;
  z-index: 100;
}

.fade-out-enter, .fade-out-leave-to {
  opacity: 0;
}

.fade-out-enter-to, .fade-out-leave {
  opacity: 1;
}
</style>
